module.exports = __webpack_public_path__ + "static/media/be.54e328f4.svg";